import { render } from "./LogoRecovery.vue?vue&type=template&id=15b99138&scoped=true"
const script = {}

import "./LogoRecovery.vue?vue&type=style&index=0&id=15b99138&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b99138"]])

export default __exports__